import { Card } from 'reactstrap';
import Datestamp from '../../Datestamp';
import React from 'react';
import { LabTestOrderTimeLineItem } from '../../../schemas/getUsersTimeline';
import { FaRegCalendarAlt } from 'react-icons/fa';

type LabTestOrderTimelineCardProps = {
  timelineItem: LabTestOrderTimeLineItem;
};

type OrderDetails = {
  courier_name?: string;
  dispatch_id?: string;
  internal_kit_order_id?: string;
  p_urn_list?: string;
  tracking_id?: string;
};

type DataItem = {
  label: string;
  value: string | Date | OrderDetails;
  isDate?: boolean;
  isDeliveryDetails?: boolean;
};

const LabTestOrderTimelineCard: React.FC<LabTestOrderTimelineCardProps> = ({ timelineItem }) => {
  const cardData: DataItem[] = [
    { label: 'Order Route', value: timelineItem.item_type_desc },
    { label: 'Order Number', value: timelineItem.item_call_type_code },
    { label: 'Appointment ID', value: `${timelineItem.appt_id}` },
    { label: 'VL ID', value: timelineItem.item_user },
    { label: 'Last Status Change Date', value: timelineItem.case_status_date, isDate: true },
    {
      label: 'Courier Tracking Details',
      value: timelineItem.imaging_provider,
      isDeliveryDetails: true
    }
  ];

  const renderDataValue = (dataItem: DataItem) => {
    const { value, isDate, isDeliveryDetails } = dataItem;
    if (!value) return 'N/A';
    if (isDate) {
      return <Datestamp date={value as Date} format="Date @ Time - 03/01/2022 @ 08:57" />;
    }
    if (isDeliveryDetails) {
      const deliveryDetails = value as OrderDetails;
      if (!deliveryDetails.internal_kit_order_id) {
        return 'N/A';
      }
      if (deliveryDetails.courier_name && deliveryDetails.tracking_id) {
        return `${deliveryDetails.courier_name} - ${deliveryDetails.tracking_id}`;
      }
      return 'Pending';
    }
    return typeof value === 'object' ? JSON.stringify(value) : `${value}`;
  };

  return (
    <Card className="itemBox ">
      {/*Title*/}
      <div className="firstLine vl-flex-row-start-useableSize timeline-card">
        <FaRegCalendarAlt className="image" />
        <span className="title">
          <Datestamp
            date={timelineItem.item_status_date}
            format="Long Date with day-of-week - Thursday, March 3rd, 2022"
          />
        </span>
      </div>

      {/*Body*/}
      {cardData.map((dataItem) => (
        <div key={dataItem.label} className="text-row bottom-space flex-wrap">
          <div className="key">{dataItem.label}:</div>
          <div className="value">{renderDataValue(dataItem)}</div>
        </div>
      ))}

      {/*Footer*/}
      <div className="footer">
        <div className="right-status">{timelineItem.item_status_desc}</div>
      </div>
    </Card>
  );
};

export default LabTestOrderTimelineCard;
